(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-button-new"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-button-new-element')) {
    class BuyButtonNewElement extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-submit-button]');
        this.submitText = this.querySelector('[data-submit-text]');
        this.spinner = this.querySelector('[data-spinner]');
        this.variantIdInput = this.querySelector('[data-variant-id]');
        this.errorEl = this.querySelector('[data-error]');
        this.statusWrapper = this.querySelector('[data-status]');

        this.cartAddUrl = '/cart/add.js';


        this.isSubmitting = false;

        this.boundSubmit = this.onSubmit.bind(this);
        this.boundVariantChange = this.onVariantChange.bind(this);

        this.form.addEventListener('submit', this.boundSubmit);
        document.addEventListener('variant:update', this.boundVariantChange);
      }

      disconnectedCallback() {
        this.form.removeEventListener('submit', this.boundSubmit);
        document.removeEventListener('variant:update', this.boundVariantChange);
      }

      onVariantChange(event) {
        const detail = event.detail;
        if (!detail || !detail.resource) return;

        const productId = detail.data && detail.data.productId;
        if (productId && String(productId) !== String(this.dataset.productId)) {
          return;
        }

        this.updateVariant(detail.resource);
      }

      updateVariant(variant) {
        this.hideError();

        if (!variant) {
          this.variantIdInput.value = '';
          this.submitButton.dataset.available = 'false';
          this.submitButton.disabled = true;
          this.setSubmitLabel(this.getLabel('unavailable'));
          this.setStatus('unavailable');
          return;
        }

        this.variantIdInput.value = variant.id;

        if (variant.available) {
          this.submitButton.dataset.available = 'true';
          this.submitButton.disabled = false;
          this.setSubmitLabel(this.getLabel('add'));
          this.setStatus('available');
        } else {
          this.submitButton.dataset.available = 'false';
          this.submitButton.disabled = true;
          this.setSubmitLabel(this.getLabel('soldout'));
          this.setStatus('soldout');
        }
      }

      getLabel(key) {
        const labels = {
          add: this.dataset.labelAdd,
          soldout: this.dataset.labelSoldOut,
          unavailable: this.dataset.labelUnavailable,
        };
        return (labels && labels[key]) || key;
      }

      setSubmitLabel(text) {
        if (text) this.submitText.textContent = text;
      }

      setStatus(state) {
        if (!this.statusWrapper) return;

        const labelMap = {
          available: this.getLabel('available') || 'Available',
          soldout: this.getLabel('soldout') || 'Sold out',
          unavailable: this.getLabel('unavailable') || 'Unavailable',
        };

        const classMap = {
          available: 'buy-button-new__status-text--available',
          soldout: 'buy-button-new__status-text--soldout',
          unavailable: 'buy-button-new__status-text--unavailable',
        };

        this.statusWrapper.innerHTML = '';
        const span = document.createElement('span');
        span.className = 'buy-button-new__status-text ' + classMap[state];
        span.setAttribute('data-status-text', state);
        span.textContent = labelMap[state];
        this.statusWrapper.appendChild(span);
      }

      async onSubmit(event) {
        event.preventDefault();

        if (this.isSubmitting) return;
        if (this.submitButton.dataset.available === 'false') return;

        this.hideError();
        this.setLoading(true);

        const formData = new FormData(this.form);

        try {
          const response = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
            },
            body: formData,
          });

          let data = {};
          try {
            data = await response.json();
          } catch (parseError) {
            data = {};
          }

          if (!response.ok) {
            const message =
              data.description || data.message || 'Unable to add this item to your cart. Please try again.';
            this.showError(message);

            document.dispatchEvent(
              new CustomEvent('cart:error', {
                bubbles: true,
                detail: { resource: data, sourceId: 'buy-button-new' },
              })
            );

            this.setLoading(false);
            return;
          }

          const cart = await fetch('/cart.js').then((r) => r.json());

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'buy-button-new',
                data: { itemAdded: data },
              },
            })
          );

          this.setLoading(false);
        } catch (error) {
          this.showError('Something went wrong. Please check your connection and try again.');
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.isSubmitting = isLoading;

        if (isLoading) {
          this.submitButton.setAttribute('aria-busy', 'true');
          this.submitButton.disabled = true;
          this.spinner.hidden = false;
          this.submitText.hidden = true;
        } else {
          this.submitButton.removeAttribute('aria-busy');
          this.spinner.hidden = true;
          this.submitText.hidden = false;
          this.submitButton.disabled = this.submitButton.dataset.available === 'false';
        }
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    customElements.define('buy-button-new-element', BuyButtonNewElement);
  }
  } catch(e) { console.error(e); }
})();

})();
